export enum CreatePipelineStepGroups {
  SOURCE_SELECTION = 'select-source',
  DESTINATION_SELECTION = 'select-destination',
  PIPELINE_CONFIGURATION = 'pipeline-config',
  OBJECT_CONFIGURATION = 'object-config',
  REVIEW = 'review'
}

export enum CreatePipelineStepPaths {
  SELECT_SOURCE_TYPE = 'select-source/select-source-type',
  SOURCE_CONNECTION_SETTINGS = 'select-source/connection-settings',
  SELECT_DESTINATION_TYPE = `select-destination/select-dest-type`,
  DESTINATION_CONNECTION_SETTINGS = 'select-destination/connection-settings',
  PIPELINE_SETTINGS = 'pipeline-config/pipeline-settings',
  CONFIGURE_OBJECTS = 'object-config/objects-settings',
  REVIEW = 'review/review-configuration'
}
